import { InjectionToken } from '@angular/core'
import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn,
} from '@simplewebauthn/browser'

export interface WebAuthnClient {
  startRegistration: typeof startRegistration
  startAuthentication: typeof startAuthentication
  browserSupportsWebAuthn: typeof browserSupportsWebAuthn
}

export const WEBAUTHN_CLIENT = new InjectionToken<WebAuthnClient>(
  'WebAuthnClient',
  {
    providedIn: 'root',
    factory: () => ({
      startRegistration,
      startAuthentication,
      browserSupportsWebAuthn,
    }),
  },
)
